import { Avatar, Box, Typography } from '@mui/material';

type YoutubeStatsTooltipSeriesHeaderProps = {
  label: string;
  color: string;
  channelThumbnailUrl?: string;
  ribbonHeight: number;
  avatarSize: number;
};

/**
 * Shared tooltip series header with color ribbon, optional channel logo, and label.
 */
export function YoutubeStatsTooltipSeriesHeader(props: YoutubeStatsTooltipSeriesHeaderProps) {
  const { label, color, channelThumbnailUrl, ribbonHeight, avatarSize } = props;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box
        sx={{
          width: 5,
          height: ribbonHeight,
          backgroundColor: color,
          borderRadius: 1,
          flexShrink: 0,
        }}
      />
      {channelThumbnailUrl ? (
        <Avatar
          src={channelThumbnailUrl}
          variant="circular"
          sx={{
            width: avatarSize,
            height: avatarSize,
            flexShrink: 0,
            border: '1px solid',
            borderColor: 'grey.400',
          }}
        />
      ) : null}
      <Typography variant="caption">{label}</Typography>
    </Box>
  );
}
